import React, { useEffect, useState } from "react";

const TaskTMdiffroute = ({ match }) => {
  const { rowID } = match.params;

  const [tmDiffs, setTmDiffs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!rowID) return;
    fetchTmDiffs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowID]);

  const fetchTmDiffs = async () => {
    setLoading(true);
    setError(null);

    try {
      const res = await fetch(
        `${window.API_URL}/task/getTMDiffs.php?rowID=${rowID}`
      );

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      const data = await res.json();
      const rows = Array.isArray(data) ? data : [];

      setTmDiffs(rows);
    } catch (err) {
      console.error("Failed to load TM diffs", err);
      setError("Failed to load TM diffs.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "2rem", color: "#c8c8c8", fontSize: "14px" }}>
      <h2>TM Differences</h2>

      {loading && <p>Loading TM diffs…</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {!loading && !error && tmDiffs.length === 0 && (
        <p>No TM diffs found for this row.</p>
      )}

      {!loading && !error && tmDiffs.length > 0 && (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: "1rem",
          }}
        >
          <thead>
            <tr style={{ borderBottom: "1px solid #ccc" }}>
              <th style={{ textAlign: "left", padding: "8px" }}>Match %</th>

              <th style={{ textAlign: "left", padding: "8px" }}>Current row</th>

              <th style={{ textAlign: "left", padding: "8px" }}>TM Source</th>
              <th style={{ textAlign: "left", padding: "8px" }}>TM Target</th>
            </tr>
          </thead>
          <tbody>
            {tmDiffs
              .slice()
              .sort((a, b) => Number(b.match_percent) - Number(a.match_percent))
              .map((row) => (
                <tr
                  key={row.id}
                  style={{
                    borderBottom: "1px solid #333",
                    verticalAlign: "top",
                  }}
                >
                  <td style={{ padding: "8px", whiteSpace: "nowrap" }}>
                    {row.match_percent}%
                  </td>

                  <td
                    style={{ padding: "8px" }}
                    dangerouslySetInnerHTML={{
                      __html: row.diff_row_html || "",
                    }}
                  />

                  <td
                    style={{ padding: "8px" }}
                    dangerouslySetInnerHTML={{
                      __html: row.diff_tm_html || "",
                    }}
                  />

                  <td
                    style={{ padding: "8px" }}
                    dangerouslySetInnerHTML={{
                      __html: row.tm_entry_target || "",
                    }}
                  />
                </tr>
              ))}
          </tbody>
        </table>
      )}

      {/* Basic styles for diff highlights */}
      <style>
        {`
          .diff-added {
            color: #007bff;
            font-weight: bold;
          }
          .diff-removed {
            color: #ff4d4f;
            
          }
        `}
      </style>
    </div>
  );
};

export default TaskTMdiffroute;
